/* eslint-disable global-require */
function encrypt(publicKey, message) {
  const JSEncrypt = require('jsencrypt');
  const JSEncryptConstructor = JSEncrypt.JSEncrypt || JSEncrypt;
  const crypto = new JSEncryptConstructor();
  crypto.setPublicKey(publicKey);
  return crypto.encrypt(message);
}

function decrypt(privateKey, message) {
  const JSEncrypt = require('jsencrypt');
  const JSEncryptConstructor = JSEncrypt.JSEncrypt || JSEncrypt;
  const crypto = new JSEncryptConstructor();
  crypto.setPrivateKey(privateKey);
  return crypto.decrypt(message);
}

module.exports = { encrypt, decrypt };
